import React from "react";

export default function LogoIcon() {
  return (
    <svg width={17} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
      <g fill="#3E4957" clipPath="url(#a)">
        <path d="M11.5 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        <path
          fillRule="evenodd"
          d="M.5 8a8 8 0 1 1 16 0 8 8 0 0 1-16 0Zm8-7a7 7 0 0 0-5.468 11.37C3.742 11.226 5.305 10 8.5 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8.5 1Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.5 0h16v16H.5z" />
        </clipPath>
      </defs>
    </svg>
  );
}
